import React from 'react';
import AllSupportUsers from 'components/SupportUsers';

const SupportUsers = () => {
    return <AllSupportUsers />;
};

export default SupportUsers;